var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loader},[_c('div',{class:_vm.$style.rubik}),_c('div',{class:_vm.$style.spinner},[_c('app-icon',{class:_vm.$style.icon,attrs:{"name":"spinner"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }